import { render, staticRenderFns } from "./ModalPassword.vue?vue&type=template&id=aeda8130"
import script from "./ModalPassword.vue?vue&type=script&lang=js"
export * from "./ModalPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports